export const KNOCKED = 'knocked';
export const BANNER_ADD = 'bannerAdd';
export const MUTE_CHANGE = 'muteChange';
export const MULTIPLE_MUTE_CHANGE = 'multipleMuteChange';
export const MULTIPLE_MUTE_CHANGED = 'multipleMuteChanged';
export const OVERLAY_ADD = 'overlayAdd';
export const OVERLAY_UPLOAD = 'overlayUpload';
export const BANNER_ADDED = 'bannerAdded';
export const MUTE_CHANGED = 'muteChanged';
export const SCENE_CREATE = 'sceneCreate';
export const SCENE_DELETE = 'sceneDelete';
export const SCENE_CREATED = 'sceneCreated';
export const SCENE_DELETED = 'sceneDeleted';
export const SCENE_UPDATE = 'sceneUpdate';
export const SCENE_UPDATED = 'sceneUpdated';
export const BANNER_UPDATE = 'bannerUpdate';
export const BANNER_DELETE = 'bannerDelete';
export const SOURCE_CREATE = 'sourceCreate';
export const SOURCE_DELETE = 'sourceDelete';
export const SOURCE_DELETED = 'sourceDeleted';
export const OVERLAY_ADDED = 'overlayAdded';
export const SOURCE_TOGGLE = 'sourceToggle';
export const SOURCE_TOGGLED = 'sourceToggled';
export const BANNER_UPDATED = 'bannerUpdated';
export const SOURCE_CREATED = 'sourceCreated';
export const KNOCK_ANSWERED = 'knockAnswered';
export const KNOCK_REJECTED = 'knockRejected';
export const KNOCK_FAILED = 'knockFailed';
export const BACKGROUND_ADD = 'backgroundAdd';
export const BANNER_DELETED = 'bannerDeleted';
export const OVERLAY_DELETE = 'overlayDelete';
export const ENDPOINT_CREATE = 'endpointCreate';
export const ENDPOINT_DELETE = 'endpointDelete';
export const ENDPOINT_UPDATE = 'endpointUpdate';
export const OVERLAY_DELETED = 'overlayDeleted';
export const STREAM_SOCKET_EVENT = 'streamEvent';
export const ENDPOINT_CREATED = 'endpointCreated';
export const ENDPOINT_DELETED = 'endpointDeleted';
export const ENDPOINT_UPDATED = 'endpointUpdated';
export const BACKGROUND_ADDED = 'backgroundAdded';
export const SCREEN_SHARE_STOP = 'screenShareStop';
export const PRESENTER_FEATURE = 'presenterFeature';
export const BACKGROUND_DELETE = 'backgroundDelete';
export const BANNER_LIVE_TOGGLE = 'bannerLiveToggle';
export const PRESENTER_FEATURED = 'presenterFeatured';
export const BACKGROUND_DELETED = 'backgroundDeleted';
export const DIRECTOR_REQUESTED = 'directorRequested';
export const SOURCE_ORDER_CHANGE = 'sourceOrderChange';
export const SCENE_LAYERS_UPDATE = 'sceneLayersUpdate';
export const BANNER_LIVE_TOGGLED = 'bannerLiveToggled';
export const OVERLAY_LIVE_TOGGLE = 'overlayLiveToggle';
export const SCENE_LAYERS_UPDATED = 'sceneLayersUpdated';
export const MEDIA_PLAYER_CHANGED = 'mediaPlayerChanged';
export const SOURCE_ORDER_CHANGED = 'sourceOrderChanged';
export const OVERLAY_LIVE_TOGGLED = 'overlayLiveToggled';
export const CAMERA_STATUS_CHANGE = 'cameraStatusChange';
export const MULTIPLE_CAMERA_STATUSES_CHANGE = 'multipleCameraStatusesChange';
export const SCREEN_SHARE_STOPPED = 'screenShareStopped';
export const AGORA_SCREEN_SHARE_STOPPED = 'agoraScreenShareStopped';
export const CAMERA_STATUS_CHANGED = 'cameraStatusChanged';
export const ATTENDEE_ROSTER_CHANGE = 'attendeeRosterChange';
export const BROADCAST_MIXER_JOINED = 'broadcastMixerJoined';
export const BACKGROUND_LIVE_TOGGLE = 'backgroundLiveToggle';
export const OVERLAY_POSITION_TOGGLE = 'overlayPositionToggle';
export const ATTENDEE_ROSTER_CHANGED = 'attendeeRosterChanged';
export const ATTENDEE_CAMERA_REMOVED = 'attendeeCameraRemoved';
export const BACKGROUND_LIVE_TOGGLED = 'backgroundLiveToggled';
export const DIRECTOR_REQUEST_ANSWER = 'directorRequestAnswer';
export const BROADCAST_PROGRAM_SYNCED = 'broadcastProgramSynced';
export const OVERLAY_POSITION_TOGGLED = 'overlayPositionToggled';
export const BROADCAST_PROGRAM_CHANGE = 'broadcastProgramChange';
export const DIRECTOR_REQUEST_ANSWERED = 'directorRequestAnswered';
export const BROADCAST_PROGRAM_CHANGED = 'broadcastProgramChanged';
export const ATTENDEE_MIC_STATUS_CHANGE = 'attendeeMicStatusChange';
export const ATTENDEE_MIC_STATUS_CHANGED = 'attendeeMicStatusChanged';
export const MULTIPLE_ATTENDEE_MIC_STATUSES_CHANGE =
  'multipleAttendeeMicStatusesChange';
export const MULTIPLE_ATTENDEE_MIC_STATUSES_CHANGED =
  'multipleAttendeeMicStatusesChanged';
export const BACKGROUND_POSITION_TOGGLE = 'backgroundPositionToggle';
export const BACKGROUND_POSITION_TOGGLED = 'backgroundPositionToggled';
export const ATTENDEE_CONNECTION_METRICS_CHANGED =
  'attendeeConnectionMetricChanged';
//See this link for event possibilities: https://docs.aws.amazon.com/ivs/latest/userguide/SUE.html#SUE-examples-stream-state-change
export const STREAM_END = 'Stream End';
export const STREAM_START = 'Stream Start';
export const STARVATION_END = 'Starvation End';
export const STREAM_FAILURE = 'Stream Failure';
export const STARVATION_START = 'Starvation Start';
export const STREAM_STATE_TOGGLE = 'streamStateToggle';
export const STREAM_STATE_TOGGLED = 'streamStateToggled';
export const STREAM_EVENTS = [
  STREAM_FAILURE,
  STREAM_END,
  STREAM_START,
  STARVATION_START,
  STARVATION_END
];
export const PRESENTER_AUDIO_BITRATE_CHANGE = 'presenterBitRateChange';
export const PRESENTER_AUDIO_BITRATE_CHANGED = 'presenterBitRateChanged';

export const BROADCAST_RECORDING_START = 'broadcastRecordingStart';
export const BROADCAST_RECORDING_STARTED = 'broadcastRecordingStarted';
export const BROADCAST_RECORDING_STOP = 'broadcastRecordingStop';
export const BROADCAST_RECORDING_STOPPED = 'broadcastRecordingStopped';
export const BROADCAST_RECORDING_CREATE = 'broadcastRecordingCreate';
export const BROADCAST_RECORDING_UPDATE = 'broadcastRecordingUpdate';
export const BROADCAST_RECORDING_DELETE = 'broadcastRecordingDelete';
export const BROADCAST_RECORDING_CREATED = 'broadcastRecordingCreated';
export const BROADCAST_RECORDING_UPDATED = 'broadcastRecordingUpdated';
export const BROADCAST_RECORDING_DELETED = 'broadcastRecordingDeleted';
export const ATTENDEE_LEFT = 'attendeeLeft';
export const MUTE_MEETING_AUDIO_CHANGE = 'muteMeetingAudioChange';
export const REAL_TIME = 'realTime';
export const MUTE_MEETING_AUDIO_CHANGED = 'muteMeetingAudioChanged';
export const UPDATE_RECORDING_ECS_TASK_STATE =
  'broadcast.updateRecordingTaskState';
export const UPDATE_STREAMING_ECS_TASK_STATE =
  'broadcast.updateStreamEndpointTaskState';
export const BROADCAST_SERVER_TIME = 'serverTime';
export const KNOCK_ANSWER = 'knockAnswer';
export const TOGGLE_ADD_SELF_LIVE = 'toggleAddSelfLive';
export const TOGGLED_ADD_SELF_LIVE = 'toggledAddSelfLive';
export const TOGGLED_PRESENTER_LIVE = 'toggledPresenterLive';
export const TOGGLED_AGORA_PRESENTER_LIVE = 'toggledAgoraPresenterLive';
export const AUTO_MUTE_TOGGLED = 'autoMuteToggled';
export const AUTO_MUTE_TOGGLE = 'autoMuteToggle';
export const TOGGLE_LAYOUT_ANIMATION = 'toggleLayoutAnimation';
export const TOGGLED_LAYOUT_ANIMATION = 'toggledLayoutAnimation';
export const BROADCAST_JOIN_SYNC_SERVER_TIME = 'broadcastSyncServerTime';
export const BROADCAST_JOIN_SYNCED_SERVER_TIME = 'broadcastSyncedServerTime';
export const ATTENDEE_NETWORK_HEALTH_CHANGED = 'attendeeNetworkHealthChanged';
export const MIXER_ATTENDEES_CAMERA_STATUS_CHANGE =
  'mixerAttendeesCameraStatusChange';
export const MIXER_ATTENDEES_CAMERA_STATUS_CHANGED =
  'mixerAttendeesCameraStatusChanged';
export const KNOCK_UPDATED = 'knockUpdated';
export const ATTENDEE_DETAILS_CHANGED = 'attendeeDetailsChanged';
export const INITIALIZED_READINESS_CHECK = 'initializedReadinessCheck';
export const CREATE_READINESS_CHECK = 'createReadinessCheck';
export const SCENE_LAYOUT_CHANGE = 'sceneLayoutChange';
export const SCENE_LAYOUT_CHANGED = 'sceneLayoutChanged';
export const CANCELLED_REQUESTS = 'cancelledRequests';
export const STREAM_RECORD_STATUS_CHANGE = 'streamRecordStatusChange';
export const ATTENDEE_SCREEN_SHARE_CANCELLED = 'attendeeScreenShareCancelled';
export const KNOCK_FAIL = 'knockFail';
export const MULTIPLE_CAMERA_STATUSES_CHANGED = 'multipleCameraStatusesChanged';
export const RENEWED_MEETING = 'renewedMeeting';
export const RENEW_MEETING = 'renewMeeting';
export const SYNC_BRANDING_SETTINGS = 'syncBrandingSettings';
export const SYNCED_BRANDING_SETTINGS = 'syncedBrandingSettings';
export const AGORA_ATTENDEE_MUTE_UNMUTE_CHANGED =
  'agoraAttendeeMuteUnmuteChanged';
export const AGORA_CAMERA_STATUS_CHANGED = 'agoraCameraStatusChanged';
